var $ed0ab9e7c53f9351$exports = {};
$ed0ab9e7c53f9351$exports = {
    "(optional)": `(voliteln\u{11B})`,
    "(required)": `(po\u{17E}adov\xe1no)`
};


export {$ed0ab9e7c53f9351$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
